import { Component, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { HelpTextComponent } from 'src/app/component/common-components/help-text/help-text.component';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { QuestionHelpTextService } from 'src/app/service/question-help-text.service';
import { DataMonitoringReportEnrollmentResult } from '../../model/data-monitoring-report-enrollment-result.model';
import { GradeAgeAlignmentService } from '../../service/grade-age-alignment.service';

@Component({
    selector: 'app-grade-age-alignment-student-dialog',
    templateUrl: './grade-age-alignment-student-dialog.component.html',
    styleUrls: ['./grade-age-alignment-student-dialog.component.scss']
})
export class GradeAgeAlignmentStudentDialogComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    settings: any = {
        '/data-monitoring-reports/grade-age-alignment': {
            TITLE: 'Grade Age Alignment Students',
            API: undefined,
            SCHOOL_YEAR: true,
            PERFORMANCE_PERIOD: false,
            QUESTION_HELP_TEXT_ID: 0,
            COLUMNS: [
                'MSD_NUMBER',
                'SSID',
                'PERSON.LAST_NAME',
                'DOB',
                'AGE',
                'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE',
                'SCHOOL_ENROLLMENT_DETAILS[0].SOURCE'
            ]
        }
    };
    currentSetting: any;

    // Component variables
    resetField: boolean = false;

    // Table display
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Tab labels
    selectedIndex: number = 0;

    // Table results
    searchResultDataSource!: MatTableDataSource<DataMonitoringReportEnrollmentResult>;

    // Results
    results: DataMonitoringReportEnrollmentResult[] = [];
    searchResultFilter: string = '';

    // Help Text
    lstQuestionHelpText: QuestionHelpText[] = [];

    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    constructor(
        private gradeAgeAlignmentService: GradeAgeAlignmentService,
        private questionHelpTextService: QuestionHelpTextService,
        router: Router,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<GradeAgeAlignmentStudentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.connectAPIs(gradeAgeAlignmentService);
        this.selectSettings(router.url);
        this.search();
    }

    connectAPIs(gradeAgeAlignmentService: GradeAgeAlignmentService) {
        this.settings['/data-monitoring-reports/grade-age-alignment'].API = function (payload: any) {
            return gradeAgeAlignmentService.search(payload);
        };
    }

    selectSettings(url: string) {
        this.currentSetting = this.settings[url];
    }

    ngOnInit(): void {}

    search() {
        if (true) {
            this.isLoading = true;
            this.msg = {};
            this.searchResultFilter = '';

            this.currentSetting.API(this.generatePayload()).subscribe({
                next: (res: any) => {
                    if (res.students) {
                        this.results = res.students.sort((n1: DataMonitoringReportEnrollmentResult, n2: DataMonitoringReportEnrollmentResult) =>
                            n1.PERSON!.LAST_NAME! > n2.PERSON!.LAST_NAME! ? 1 : -1
                        );

                        // Updates the Tables to be displayed w/ this.results
                        this.updateDataSource();
                    } else if (res.msg) {
                        this.results = [];
                        this.msg = res.msg;
                    } else {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving ' + this.currentSetting.TITLE + '.' };
                    }
                },
                error: (err: any) => {
                    this.results = [];
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving ' + this.currentSetting.TITLE + '.' };
                },
                complete: () => {
                    // Display results
                    this.isLoading = false;

                    // Set to first tab
                    this.selectedIndex = 0;
                }
            });
        }
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.data?.chosenRegions;
        payload.chosenCounties = this.data?.chosenCounties;
        payload.chosenSchoolDistricts = this.data?.chosenSchoolDistricts;
        payload.chosenSchools = this.data?.chosenSchools;
        payload.schoolYear = this.data?.schoolYear;
        payload.performancePeriod = this.data?.performancePeriod;

        payload.grade = this.data?.GRADES;
        payload.age = this.data?.AGE === 'Total For Grade' ? null : this.data?.AGE;

        return payload;
    }

    updateDataSource() {
        setTimeout(() => {
            this.updateResultDataSource();
        });
    }
    updateResultDataSource() {
        // Display Columns
        this.displayedColumns = this.currentSetting.COLUMNS;

        // Data
        this.searchResultDataSource = new MatTableDataSource<DataMonitoringReportEnrollmentResult>();
        this.searchResultDataSource.data = this.results;

        // Paginator
        this.searchResultDataSource.paginator = this.paginators.toArray()[0];

        // Sort
        this.searchResultDataSource.sort = this.sorts.toArray()[0];
        const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
        this.searchResultDataSource.sort.active = defaultSort.active;
        this.searchResultDataSource.sort.direction = defaultSort.direction;
        this.searchResultDataSource.sort.sortChange.emit(defaultSort);
        this.searchResultDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

        // Filter
        this.searchResultDataSource.filterPredicate = (data: any, filter) => {
            const dataStr = JSON.stringify(data).toLowerCase();
            return dataStr.indexOf(filter) != -1;
        };
    }

    setFilter(searchResultDataSource: any, filter: string) {
        searchResultDataSource.filter = filter.trim().toLocaleLowerCase();
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    // Help Text
    invokeHelpTextAPI() {
        this.questionHelpTextService.getHelpText(this.currentSetting.QUESTION_HELP_TEXT_ID).subscribe((lstQuestionHelpText: QuestionHelpText[]) => {
            this.lstQuestionHelpText = lstQuestionHelpText;
        });
    }

    displayHelpText(qId: number) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.maxHeight = '80vh';
        dialogConfig.data = this.returnHelpText(qId);
        const dialogRef = this.dialog.open(HelpTextComponent, dialogConfig);
    }

    returnHelpText(qId: number): string {
        let questionHelpText = this.lstQuestionHelpText.find((x) => x.QUESTIONS_ID == qId);

        if (questionHelpText) return questionHelpText?.HELP_TEXT;
        else return '';
    }
}
